import React from "react";

import Skeleton from "@/components/shared/Skeleton";

/**
 * Placeholder rows for a table that cannot load yet.
 *
 * Both the user page and the role page hold their table until a SuperAdmin has
 * picked a working tenant, so neither ever sends an unscoped cross-tenant read.
 * This is what stands in the table's place until then.
 */
export const TableSkeleton = ({ rows = 6 }) => (
  <div className="p-4 flex flex-col gap-2">
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton key={index} className="h-10 w-full rounded-lg" />
    ))}
  </div>
);

export default TableSkeleton;
